import React from 'react';
import { Box, Modal, Portal, IconButton } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';


const PDFPreviewModal = ({ url, handleClose }) => (
  <Portal>
    <Modal open={true}>
      <Box style={{ width: '100vw', height: '100vh', overflow: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <iframe src={url} border="0" width={'80%'} height={'90%'}></iframe>
        <IconButton style={{ position: 'fixed', top: '20px', right: '20px' }} onClick={handleClose} color="primary">
          <CloseIcon/>
        </IconButton>
      </Box>
    </Modal>
  </Portal>
);


export default PDFPreviewModal;
